import * as Yup from "yup";

export const ActivityReportFilterForm = {
  type: "",
  customerOriginationArea:"",
  traffic: false,
  include_customer_types: []
};

export const ActivityReportSchema = Yup.object().shape({
  type: Yup.string()
    .default("All Activity Types")
    .nullable(),
  customerOriginationArea: Yup.string()
    .nullable(),
  traffic: Yup.bool().default(false),
  include_customer_types: Yup.array().default([])
});